'use strict';
module.exports = function (x) {
	return x === 0 && 1 / x === -Infinity;
};



//////////////////
// WEBPACK FOOTER
// ./~/negative-zero/index.js
// module id = 1386
// module chunks = 0